(function () {
  // v11 (27.10, John): ingen fast kjøpslinje på mobil (kjøpsknappen ligger høyt på siden, og linja kom i tillegg til bunnmenyen).
  if (window.matchMedia('(max-width: 749px)').matches) return;
  // Finn kjøpsknappen FØRST, ikke skjemaet.
  // Bakgrunn (14.08.2026): koden hentet før
  //   document.querySelector('.product__info-wrapper form[action="/cart/add"]')
  // Shopifys «betal i avdrag»-boks er OGSÅ et form[action="/cart/add"] og
  // ligger først i DOM-en. Den har ingen submit-knapp, så neste linje ga
  // null og hele funksjonen avsluttet. Resultat: den fastlåste
  // kjøpsknappen ble aldri laget på noen produktside.
  const submitButton =
    document.querySelector('.product__info-wrapper .product-form__submit') ||
    document.querySelector('.product__info-wrapper form[action="/cart/add"] [type="submit"]');
  if (!submitButton) return;

  const form = submitButton.closest('form');
  if (!form) return;

  const sticky = document.createElement('div');
  sticky.className = 'fj-sticky-atc';

  const stickyButton = document.createElement('button');
  stickyButton.type = 'button';
  stickyButton.className = 'fj-sticky-atc__btn';
  sticky.appendChild(stickyButton);
  document.body.appendChild(sticky);

  function syncButton() {
    const label = submitButton.textContent.trim();
    stickyButton.textContent = label || 'Legg i handlekurv';
    stickyButton.disabled = submitButton.disabled;
    if (submitButton.disabled) {
      sticky.classList.remove('is-visible');
    }
  }

  stickyButton.addEventListener('click', () => {
    if (submitButton.disabled) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    submitButton.click();
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const shouldShow = !entry.isIntersecting;
        sticky.classList.toggle('is-visible', shouldShow && !submitButton.disabled);
      });
    },
    { rootMargin: '0px 0px -40% 0px' }
  );

  observer.observe(form);
  syncButton();

  const mutation = new MutationObserver(syncButton);
  mutation.observe(submitButton, { attributes: true, childList: true, subtree: true });
})();
